import script from "./valueItem.vue?vue&type=script&setup=true&lang=js"
export * from "./valueItem.vue?vue&type=script&setup=true&lang=js"

import "./valueItem.vue?vue&type=style&index=0&id=aa68a3cc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa68a3cc"]])

export default __exports__